<template>
<div class="Menu" style="width:100%; height:100%;background-color:gainsboro;">
  <div class="tree">
    <v-tree ref='tree' :data='treeData' :multiple="false"  :tpl='tpl' :halfcheck='true' :allowGetParentNode='true' :selectAlone='true' :radio='true'/>
  </div>
</div>
</template>


<script>
import axios from 'axios';
var data_root = "./data"
var campus_json = data_root+"/"+"campus.json";
var buildings_json = data_root+"/"+"buildings.json";
var floors_json = data_root+"/"+"floors.json";
export default {
  name: 'Menu',
  data () {
    return {
      searchword: '',
      initSelected: ['node-1'],
      // とりあえず空に
		buildings: [],
		floors: [],
		treeData: [],
    }
  },
	mounted: function(){
		axios.get(campus_json).then(response => {
			// TODO axois を三回ネストした後に下の関数を実行
			this.campuses = response.data
			// console.log(this.campus)
			axios.get(buildings_json).then(buildings => {
				this.buildings = Object.keys(buildings.data).map(function (key) {return buildings.data[key]})
				axios.get(floors_json).then(floors => {
					this.floors = Object.keys(floors.data).map(function (key) {return floors.data[key]})
					this.create_tree()
				}).catch(err => {
					console.error(err)
				})
			}).catch(err => {
				console.error(err)
			})
		}).catch(err => {
			console.error(err)
		})
	},
  methods: {
    // tpl (node, ctx, parent, index, props) {
    tpl (...args) {
      let {0: node} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
	let wrapperClass = node.selected ? 'nodewrapper nodewrapper-selected' : 'nodewrapper'
	let nodeclass = "campusnode";
	if(node.parent){
		nodeclass = "buildingnode"
		if(node.parent().parent){
			nodeclass = "floornode"
		}
	}
	if (node.searched) titleClass += ' node-searched'
      return <div class = {nodeclass}>
		<div class = {wrapperClass} onClick={() => {
			node.expanded = !node.expanded;
			node.selected = node.expanded;
			let checked = this.$refs.tree.getSelectedNodes({isOriginal : true});
			for(let n in checked){
				var tempnode = {...node};
				var to_close = true;
				while(tempnode.parent){
					if(tempnode.parent() == checked[n]){
						to_close = false;
						break;						
					}
					else{
						tempnode = tempnode.parent();
					}
				}

				if(node.expanded & checked[n].expanded &  (checked[n] != node) & to_close){
					checked[n].selected = false;
					checked[n].expanded = false;
				}
			}
			if(node.send)this.doUpdate({campus:node.campus_id, building: node.building_id, floor: node.id});
         }}>
         <span class={titleClass} domPropsInnerHTML={node.title}>
		</span>
      </div>
	</div>
    },
    search () {
      this.$refs.tree.searchNodes(this.searchword)
    },
		create_tree () {
			for(let campus in this.campuses) {
				let campus_entry = {send: false, title: this.campuses[campus].campus_name, expanded: false}
				let campus_children = []
					let buildings_filtered = this.buildings.filter( (value) => {
						return (value['campus_id'] == this.campuses[campus].id)
					})				
					for(let building in buildings_filtered) {
						let building_children = []
						let building_entry = {send: false, title: buildings_filtered[building].building_name, expanded: false}
						let floors_filtered = this.floors.filter ( (value) => {
							return (value['building_id'] == buildings_filtered[building].id)
						})
						for(let floor in floors_filtered) {
							building_children.push({title: floors_filtered[floor].floor_name, 
								campus_id: this.campuses[campus].id, building_id:  buildings_filtered[building].id, id: floors_filtered[floor].id, 
								send: true, expanded: false})
						}
						building_entry.children = building_children
						campus_children.push(building_entry)
					}

				campus_entry.children=campus_children
				this.treeData.push(campus_entry)
			}
		},
	doUpdate(event){
		//ディスパッチでstoreのアクションを呼んでいる
		// this.$store.dispatch('doUpdate', event)
		this.$store.dispatch('UpdateMap', event)
	}

  },
  computed:{
    message(){
      return this.$store.getters.message
    }
  }
}
</script>

<style>
div {
	margin: 0px;
	padding: 0px;
	text-align: left;
}

h1 {
	font-size: 72pt;
	font-weight: bold;
	text-align: right;
	letter-spacing: -8px;
	color: #f0f0f0;
	margin: 0px;
}

p {
	margin: 0px;
	color:#666;
	font-size:16pt;
}

.Menu {
	margin: 0px;
	color:#666;
	font-size:16;
	text-align: left;
}

.tree{
	height: 100%; 
    overflow-y: scroll;
}
</style>
